import { TrainingHome } from "@/components/training-simulator/training-home.tsx";
import {
  buildAbilityFromContext,
  requirePermission,
} from "@/lib/casl/route-guards.ts";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/training/")({
  component: TrainingHome,
  beforeLoad: ({ context }) => {
    const ability = buildAbilityFromContext(context.user);
    if (ability.can("read", "training-simulator-reviews")) {
      throw redirect({
        to: "/training/review",
      });
    } else {
      requirePermission(context.user, "read", "training-simulator");
    }
  },
});
